import { useParams } from "react-router-dom";
import { ClientHeader } from "@/widgets/client-header";
import { CampaignList } from "@/widgets/campaign-list";
import { useAgencyClientsQuery } from "@/entities/agency-client";

export const ClientCampaignsPage = () => {
  const { client: clientParam } = useParams<{ client: string }>();
  const { data: clients = [] } = useAgencyClientsQuery();

  const currentClient = clients.find(
    (c) => c.login === clientParam || String(c.client_id) === clientParam
  );

  return (
    <div className="flex flex-col gap-6">
      <ClientHeader
        clientLogin={currentClient?.login || clientParam || ""}
        clientInfo={currentClient?.client_info}
        clientId={currentClient?.client_id}
      />
      <CampaignList clientLogin={currentClient?.login || clientParam} />
    </div>
  );
};
